<span class="btn_status_container"
  [class.status-pill-solid]="isSolid"
  [ngStyle]="{ border: '1px solid ' + borderColor, 'background-color': background }"
  [matTooltip]="label || ''"
  [matTooltipDisabled]="!label"
  matTooltipPosition="above">
  <!-- Solid drops the coloured dot: the fill already carries the status colour,
       matching the detail-page header badge. Structure unchanged from before. -->
  @if (isSolid) {
    <span class="status_circle" [ngStyle]="{ 'background-color': 'transparent' }">
      <span class="status-label" [ngStyle]="{ color: textColor }">
        {{ (label || '') | truncate : truncateLength }}
      </span>
    </span>
  } @else {
    <!-- Tint: textColor is computed for contrast against the pill's own
         white/pale background (see getReadableTextOnWhite), not against the
         dot's solid colour fill. The label must sit outside the dot — as a
         sibling on the white pill background — rather than nested inside it,
         or a dark status colour renders dark-on-dark and disappears (e.g. a
         near-black status color made the label unreadable once the dot was
         sized to fit its text; previously the dot was capped ~10px so the
         label overflowed onto the white background by accident, masking
         this). The dot itself stays a small fixed circle via inline styles
         so it isn't stretched by the shared .status_circle sizing rule
         (styles.scss) intended for the full-width pill usages. -->
    <!-- Grouped in one wrapper: .btn_status_container is `justify-content:
         space-between` (to push the lock icon to the far right), so the dot
         and label must be a single flex item or space-between pushes them to
         opposite edges of the pill instead of keeping them together on the
         left. -->
    <span class="status-pill-dot-group" style="display: flex; align-items: center;">
      <span class="status_circle"
        [ngStyle]="{
          'background-color': color,
          width: '10px',
          height: '10px',
          'min-width': '10px',
          padding: '0',
          'border-radius': '50%'
        }">
      </span>
      <span class="status-label" [ngStyle]="{ color: textColor, 'white-space': 'nowrap' }">
        {{ (label || '') | truncate : truncateLength }}
      </span>
    </span>
  }
  @if (locked) {
    <span class="status-lock-icon">
      <mat-icon [ngStyle]="{ color: textColor || '#808080' }"
        [matTooltip]="lockTooltip"
        aria-hidden="false"
        aria-label="Status locked"
        fontIcon="lock">
      </mat-icon>
    </span>
  }
</span>
